
	import { defineComponent } from 'vue';

	import LoadingSpinner from '@/ChildrenComponents/LoadingSpinner.vue';
	import IncorrectPermissions from '@/ChildrenComponents/IncorrectPermissions.vue';
	import FiscalYearReportSearch from '@/ChildrenComponents/Reports/FiscalYearReportSearch.vue';
	import FiscalYearReportTable from '@/ChildrenComponents/Reports/FiscalYearReportTable.vue';

	import { ComponentType } from '@/Enums/ComponentType';

	import { IInternalUser } from '@/Models/IInternalUser';
	import { IProgramDrugTestReport, IProgramDrugsFoundReport, IFiscalYearReportSearch } from '@/Models/Report/IPhaseReport';
	import { IDataTableHeader } from '@/Models/IDataTableHeader';

    import { ReportService } from '@/Services/Report/report-service';
    import { doesUserRoleHaveComponentViewPermissions } from '@/Services/Helper/component-permissions-helper';
	import { useUserStore } from '@/Services/Store/user-store';

	export default defineComponent({
		name: 'program-served-report',
		components: { LoadingSpinner, IncorrectPermissions, FiscalYearReportSearch, FiscalYearReportTable },
		setup(): { currentUser: IInternalUser | null } {
			const userStoreInstance = useUserStore();
			return { currentUser: userStoreInstance.$state.cstInternalUser };
		},
		data () {
			return {
				testData: [] as IProgramDrugTestReport[],
				drugData: [] as IProgramDrugsFoundReport[],
				isLoading: false,
				isSearching: false,
				testHeaders: [
                    { title: "Program", key: "programName", sortable: true, align: "start" },
                    { title: "Test Result", key: "result", sortable: true, align: "start" },
                    { title: "Unique Count", key: "uniqueParticipantCount", sortable: true, align: "start" },
				] as IDataTableHeader[],
				drugHeaders: [
                    { title: "Program", key: "programName", sortable: true, align: "start" },
                    { title: "Substance", key: "substance", sortable: true, align: "start" },
                    { title: "Unique Count", key: "uniqueParticipantCount", sortable: true, align: "start" },
				] as IDataTableHeader[],
			}
		},
		methods: {
			getReportData(searchDto: IFiscalYearReportSearch) {
				this.isSearching = true;
				Promise.all([ReportService.getProgramDrugTestReportData(searchDto), ReportService.getProgramDrugsFoundReportData(searchDto)])
					.then(([testResults, drugResults]) => {
						this.testData = testResults;
						this.drugData = drugResults;
					}).finally(() => this.isSearching = false);
			}
		},
		computed: {
			canView(): boolean {
				return doesUserRoleHaveComponentViewPermissions(this.currentUser?.attachedRoles ?? [], ComponentType.Report);
			},
		},
	});
